import config from '@/config';
import request from '@/request/request.gateway.js';
import qs from 'qs';

export default {
	// 获取全校共享空间列表
	getSchoolSharedSpace(params) {
		return request({
			method: 'get',
			url: `${config.api.workneapi}/filesystem/v1/file_list`,
			params
		});
	},
	// 获取班级空间列表
	getClassSpace(params) {
		return request({
			method: 'get',
			url: `${config.api.workneapi}/filesystem/v1/file_list`,
			params
		});
	},
	// 获取复制和移动的全校共享空间/班级空间文件夹列表
	getCopyAtMove(params) {
		return request({
			method: 'get',
			url: `${config.api.workneapi}/filesystem/v1/folder_list`,
			params
		});
	},
	// 获取搜索文件接口
	getSearchFile(params) {
		return request({
			method: 'get',
			url: `${config.api.workneapi}/filesystem/v1/search_file`,
			params
		});
	},
	// 获取添加文件夹接口
	postAddFolder(data) {
		return request({
			method: 'post',
			url: `${config.api.workneapi}/filesystem/v1/add_folder`,
			data: qs.stringify(data)
		});
	},
	// 获取添加文件接口
	postAddFile(data) {
		return request({
			method: 'post',
			url: `${config.api.workneapi}/filesystem/v1/add_file`,
			data: qs.stringify(data)
		});
	},
	// 批量复制文件或者文件夹
	postCopyFile(data) {
		return request({
			method: 'post',
			url: `${config.api.workneapi}/filesystem/v1/copy_file`,
			data: qs.stringify(data)
		});
	},
	// 批量移动文件或者文件夹
	postMoveFile(data) {
		return request({
			method: 'post',
			url: `${config.api.workneapi}/filesystem/v1/move_file`,
			data: qs.stringify(data)
		});
	},
	// 批量删除文件或者文件夹
	postDeleteFile(data) {
		return request({
			method: 'post',
			url: `${config.api.workneapi}/filesystem/v1/delete_file`,
			data: qs.stringify(data)
		});
	},
	// 批量删除文件或者文件夹
	getClassId(params) {
		return request({
			method: 'get',
			url: `${
				config.api.admin
			}/SchoolStruct/Class/get_grade_class_list_by_schoolid`,
			params
		});
	}
};
